import type { Dayjs } from 'dayjs';
import type { DateRange } from 'src/components/range-availability-calendar';

import dayjs from 'dayjs';

import { isDateWithinRange } from 'src/components/range-availability-calendar/utils';

export type ActivityDateRangePickerBounds = DateRange & {
  hasSelectableRange: boolean;
};

export const getActivityDateRangePickerBounds = (
  completionWindow: DateRange
): ActivityDateRangePickerBounds => {
  const today = dayjs().startOf('day');
  const windowFrom = completionWindow.from.startOf('day');
  const windowTo = completionWindow.to.startOf('day');
  const from = windowFrom.isAfter(today, 'day') ? windowFrom : today;

  return {
    from,
    to: windowTo,
    hasSelectableRange: !from.isAfter(windowTo, 'day'),
  };
};

export const isValidMobiscrollDateRange = (value: unknown): value is [Date, Date] =>
  Array.isArray(value) &&
  value.length === 2 &&
  value[0] instanceof Date &&
  value[1] instanceof Date &&
  !Number.isNaN(value[0].getTime()) &&
  !Number.isNaN(value[1].getTime());

export const normalizeMobiscrollRangeValue = (value: unknown): [Date, Date] | null => {
  if (!Array.isArray(value) || value.length === 0) {
    return null;
  }

  const start = value[0];
  if (!(start instanceof Date) || Number.isNaN(start.getTime())) {
    return null;
  }

  const end = value[1];
  if (end instanceof Date && !Number.isNaN(end.getTime())) {
    return [start, end];
  }

  // Mobiscroll emits only the start date while the user is picking a new range.
  return [start, start];
};

export const isMobiscrollRangeWithinBounds = (
  range: [Date, Date],
  bounds: DateRange
): boolean =>
  isDateWithinRange(dayjs(range[0]).startOf('day'), bounds) &&
  isDateWithinRange(dayjs(range[1]).startOf('day'), bounds);

export const mobiscrollRangeToDayjs = (range: [Date, Date]): { start: Dayjs; end: Dayjs } => ({
  start: dayjs(range[0]).startOf('day'),
  end: dayjs(range[1]).startOf('day'),
});
